<template>
  <div>
    <!-- page wrapper start -->
    <div class="pg-wrapper store-profile" v-if="locationNotFound">
      <app-header :class="'fixed'"></app-header>
      <main class="content-wrapper has-background-white-bis min-80vh mt-50 location-not-found">
        <h2>Location not found!</h2>
      </main>
    </div>

    <div class="pg-wrapper store-profile" v-else>
      <app-header></app-header>
      
      <main class="content-wrapper has-background-white-bis min-80vh" v-if="!loadedDetail">
        <skeleton-main />
      </main>

      <main
        :class="'content-wrapper has-background-white-bis '+ (vg_orderNotification.show ? 'has-notification' : '')"
        v-else
      >
      
        <!-- Section banner -->
        <section
          v-if="!kioskMode && !hideHeader && storeFeaturedImage"
          id="store-profile-banner"
          class="banner store-profile-banner banner-bg"
          :style="storeFeaturedImage ? 'background:url('+storeFeaturedImage+') center center/cover' : ''"
        > <!--  class="'banner store-profile-banner banner-bg '+ ( hideBanner ? 'hide':'' )" -->
          <div class="container is-flex is-fluid justify-content-end mt15">
            <button
              v-if="userLoggedIn"
              @click="isFavLocation ? unFavouriteLocation() : favouriteLocation()"
              :class="isFavLocation ? 'button btn-rounded fav-store' : 'button btn-rounded'"
            >
              <i :class="isFavLocation ? 'fas fav-btn fa-heart' : 'far fav-btn fa-heart'"></i>
            </button>
          </div>
        </section>

        <!-- Section:  Store Menu nav   hide-body-tabs-->
        <section class="body-cat-search-stripe storeprofile-category-band" :style="'top:'+categoryStripeStickyAt+'px'"> 
        <!-- :class="'relative body-cat-search-stripe' + (hideBanner ? ' fixed' : '') + (show_banner ? ' ' : ' fixed')" -->
          <section>
            <div class="search-bar">
              <!-- <div class="search-bar" style="padding-left: 13%;"> -->
              <div class="container">
                 <button
                 @click.prevent="filter_mobile = true"
                  class="mobile-filter-menu"
                >
                  <i class="fa fa-bars" aria-hidden="true"></i> MENU
                </button>
                
                <!-- <button
                  @click="switchToSearchbar"
                  class="button is-borderless-right is-inline-flex search-btn"
                >
                  <span class="icon is-fullheight">
                    <i class="fas fa-search font-color"></i>
                  </span>
                </button> -->

                <!-- state: .is-active for current/active list item   h-slider loadedCategories && -->
   
                <div v-if="onLoadCategories.length > 0" class="category-list xl-cat-list">
          
                  <swiper
                    ref="swiper"
                    :slides-per-view="slidePerView"
                    :scrollbar="{ draggable: true }"
                    :loop="false"
                    :navigation="nav"
                    :initialSlide="initialSlide"
                    :slidesPerGroup="2"
                    :freeMode="true"
                    :spaceBetween="10"
                    :breakpoints="breakpoints"
                    :observer="true"
                    :observeParents="true"
                  >
                  <swiper-slide
                   v-bind:key="'cat_slide_'+index" 
                   v-for="(category, index) in onLoadCategories" 
                   
                  >
                    <div :class="category.active ? 'category-item is-active' : 'category-item'">
                      <a href="#" @click.prevent="changeCategory(index)" class="has-text-weight-semibold is-size-6">
                        <span>{{ category.title }}</span>
                      </a>
                    </div>
                  </swiper-slide>
                </swiper>
                <div class="budler-custom-arrow arrow-prev" @click="prev">
                  <svg width="11px" height="17px" viewBox="0 0 11 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <g id="-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <g id="cat_items_arrrow_left" transform="translate(-17.000000, -113.000000)" fill="#302F30">
                              <g id="Icon/Arrow/Line/Left" transform="translate(17.000000, 113.000000)">
                                  <g id="Arrow" transform="translate(5.500000, 8.500000) scale(-1, 1) rotate(-90.000000) translate(-5.500000, -8.500000) translate(-2.500000, 3.500000)">
                                      <path d="M12.7512595,-2.66130014 C12.3864007,-3.07503886 11.7553807,-3.11530894 11.3408693,-2.75130761 L3.33865585,4.24927355 C3.12334585,4.43912235 3,4.71231141 3,4.99933582 C3,5.28636023 3.12334585,5.55954928 3.33865585,5.74939808 L11.3408693,12.7499792 C11.523224,12.9107703 11.7579123,12.9996502 12.0010519,13 C12.2883586,12.9996363 12.5616372,12.8757739 12.7512595,12.6599718 C13.1153313,12.2455407 13.0750534,11.6146428 12.6612346,11.2498547 L5.51925902,4.99933582 L12.6612346,-1.25118308 C13.0750534,-1.61597117 13.1153313,-2.24686907 12.7512595,-2.66130014 Z" id="Path" transform="translate(8.000000, 5.000000) scale(-1, 1) rotate(-90.000000) translate(-8.000000, -5.000000) "></path>
                                  </g>
                              </g>
                          </g>
                      </g>
                  </svg>
                </div>
                <div class="budler-custom-arrow arrow-next" @click="next">
                  <svg width="9px" height="14px" viewBox="0 0 9 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="cat_items_arrrow_right" transform="translate(-1226.000000, -808.000000)" fill="#302F30">
                            <g id="Group-6-Copy" transform="translate(1215.000000, 800.000000)">
                                <g id="Icon/Arrow/Line/Left" transform="translate(15.000000, 14.750000) scale(-1, 1) translate(-15.000000, -14.750000) translate(10.000000, 8.000000)">
                                    <g id="Arrow" transform="translate(4.537500, 7.012500) scale(-1, 1) rotate(-90.000000) translate(-4.537500, -7.012500) translate(-2.062500, 2.887500)">
                                        <path d="M10.519789,-2.19557262 C10.2187806,-2.53690706 9.69818904,-2.57012988 9.3562172,-2.26982878 L2.75439107,3.50565068 C2.57676033,3.66227594 2.475,3.88765691 2.475,4.12445205 C2.475,4.36124719 2.57676033,4.58662816 2.75439107,4.74325342 L9.3562172,10.5187329 C9.5066598,10.6513855 9.70027764,10.7247114 9.90086785,10.725 C10.1378958,10.7246999 10.3633507,10.6225135 10.519789,10.4444767 C10.8201483,10.1025711 10.7869191,9.58208031 10.4455185,9.28113014 L4.55338869,4.12445205 L10.4455185,-1.03222604 C10.7869191,-1.33317621 10.8201483,-1.85366698 10.519789,-2.19557262 Z" id="Path" transform="translate(6.600000, 4.125000) scale(-1, 1) rotate(-90.000000) translate(-6.600000, -4.125000) "></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                  </svg>
                </div>

                </div>
              </div>
            </div>
          </section>

          <!-- Section: SearchBar -->
          <section :class="searchbar ? 'body-searchbar show' : 'body-searchbar hide'">
            <div class="container">
              <div class="search-bar">
                <div class="control search-input">
                  <span class="icon is-fullheight">
                    <i class="fas fa-search"></i>
                  </span>
                  <input
                    v-model="searchText"
                    class="input is-fullheight is-borderless is-shadowless"
                    type="text"
                    placeholder="Search..."
                    @keyup.enter="searchProduct($event)"
                    id="search_text_bottom"
                  />
                  <a @click.prevent="switchToCategorybar" href="#" class="btn-close is-small"></a>
                </div>
              </div>
            </div>
          </section>
        </section>

        <!-- Category products -->
        <div v-if="loadedLocationProducts == false">
          <skeleton-filter-With-item />
        </div>

        <section
          v-else
          id="section-search-results"
          :class="'section-search-results'"
        >
        
          <!-- <loading v-if="loadedLocationProducts == false"></loading> -->
   
          <div class="container xl">
            <div class="columns is-multiline is-mobile justify-content-between">

              <!-- sidebar -->
              <div class="column is-12-mobile is-4-tablet is-3-desktop is-3-widescreen is-hidden-mobile">
                <div class="columns is-mobile">
                  <div class="column">
                    <filter-product :sort="vg_filters.sort" :sizes="sizes" :categoryintensity="activecategoryintensity" :activesubcategory="activeCategorySubcategories"></filter-product>
                  </div>
                </div>
              </div>
              <!-- sidebar ends-->

              <div class="column is-12-mobile is-8-tablet is-9-desktop is-9-widescreen">

                <!-- filter and sorting -->
                <div class="columns mb0 is-multiline is-variable is-1-tablet wrapper-675px-only-desktop_1">
                  <div class="column is-12-tablet is-12-desktop is-12-widescreen is-hidden-tablet">
                    <div class="mobile-active-filter-tags">
                      <ul v-if="activeFilterTags.length > 0">
                        <li class="is-size-14" @click="removeThisFilter(filterTags['key'], filterTags['val'])" v-for="filterTags  in activeFilterTags" v-bind:key="'filter_tag'+ filterTags['key'] + filterTags['val']">
                          {{ filterTags['displayVal'] }}
                          <i class="fas fa-times"></i>
                        </li>
                        <li class="clear-all border-none font-color" @click="clearAllFilters()">Clear all</li>
                      </ul>
                    </div>

                    <div class="mobile-store-product-count">
                      <p>{{ getActiveCategoryProductCount > 1 ? getActiveCategoryProductCount + ' Product(s)' : getActiveCategoryProductCount + ' Product' }}</p>
                      <p>Sort by: {{ sortKeyValues[vg_filters.sort] }}</p>
                    </div>
                    <div class="mobile-store-sort-filters">
                      <button class="font-color" @click="openFlyOutFilterDisplay()">
                        Filter ({{ activeFilterCount }})  <i class="fas fa-sliders-h"></i>
                      </button>
                        <button class="font-color" @click="openFlyOutSortDisplay()" >
                        Sort <i class="fas fa-angle-down"></i>
                      </button>
                      
                    </div>
                    <display-item-type />
                  </div>
                  <div class="column is-12-tablet is-12-desktop is-12-widescreen is-hidden-mobile pb0"><!-- is-hidden-mobile -->
                    <div class="product-shorting has-text-right">
                      
                     <display-item-type />

                      <span class="product-short-count has-text-weight-semibold font-color">{{ getActiveCategoryProductCount > 1 ? getActiveCategoryProductCount + ' Product(s)' : getActiveCategoryProductCount + ' Product' }}</span>
                      <label for="sort_by" class="font-color sort-by-label has-text-weight-semibold">
                        <span class="font-color">Sort by: </span>
                        <select v-model="vg_filters.sort" id="sort_by" class="product-short font-color" :disabled="getActiveCategoryProductCount < 1">
                          <option v-for="(val,key) in sortKeyValues" v-bind:key="key" :value="key">{{ val }}</option>
                        </select>
                      </label>
                    </div>
                  </div>
                </div>
                 <!-- filter and sorting ends -->

                <!-- product card display area -->
                <div class="columns mb0 is-multiline is-variable is-1-tablet">
                  
                  <!-- if product loading -->
                  <div class="column is-12-tablet is-12-desktop is-12-widescreen" v-if="!loadedCategoryProducts">
                    <div class="columns is-multiline is-variable is-1-tablet mt5" v-if="vg_storeItemDisplayType == 'grid'">
                      <skeleton-item v-for="i in 6" v-bind:key="'ske-item-'+i" />
                    </div>
                    <div class="mt20" v-if="vg_storeItemDisplayType == 'list'">
                      <skeleton-item-list v-for="i in 6" v-bind:key="'ske-item-'+i" />
                    </div>
                  </div>

                 
                  <!-- if product available or fetched -->
                  <div class="column store-cat-items" v-else>
               
                    <p v-if="displayCategoryProduct.length < 1" class="text-center mt20">No category with product found.</p>
                    
                    <div id="loadProduct" ref="loadProduct">
                      <div  v-for="(category, index) in displayCategoryProduct">
                        <template v-if="category.active">
                          
                          <div id="" v-bind:key="index + '-category-items'" :class="vg_storeItemDisplayType == 'grid' ? 'wrap-is-constant-240px mt20' : 'is-constant-list-full-wrap mt20'"  v-if="!isActiveSubCat">
                            <div :class="vg_storeItemDisplayType == 'grid' ? 'is-constant-240px' : 'is-constant-list-full'" 
                              v-bind:key="itemIndex + '-item'" 
                              v-for="(item, itemIndex) in category.items_visible">  <!--  work here -->
                              
                              <template v-if="vg_storeItemDisplayType == 'grid'">
                                <weed-card 
                                  v-if="item.product_family == 'cannabis'" 
                                  :callback="goToLocationProductDetail" 
                                  :item="item" 
                                ></weed-card>
                                <accessory-card 
                                  v-else
                                  :callback="goToLocationProductDetail" 
                                  :item="item" 
                                ></accessory-card>
                              </template>
                              <template v-else>
                                <weed-card-list 
                                  v-if="item.product_family == 'cannabis'" 
                                  :callback="goToLocationProductDetail" 
                                  :item="item" 
                                ></weed-card-list>
                                <accessory-card-list
                                  v-else
                                  :callback="goToLocationProductDetail" 
                                  :item="item" 
                                ></accessory-card-list>
                              </template>
                            </div>

                            <div class="container mt-15 text-center" v-if="category.total_items < 1">
                              <em class="font-color">No Product Found.</em>
                            </div>
                          </div>

                          <div :class="vg_storeItemDisplayType == 'grid' ? 'wrap-is-constant-240px mt20' : 'is-constant-list-full-wrap mt20'" v-bind:key="index + '-category-items'" v-else>

                            <div 
                              :class="vg_storeItemDisplayType == 'grid' ? 'is-constant-240px' : 'is-constant-list-full'" 
                              v-bind:key="itemIndex + '-subcatitem'" 
                              v-for="(item, itemIndex) in category.from_categories_filtered_products_visible "><!-- from_categories_filtered_products-->
                              
                              <template v-if="vg_storeItemDisplayType == 'grid'">
                                <weed-card 
                                  v-if="item.product_family == 'cannabis'" 
                                  :callback="goToLocationProductDetail" 
                                  :item="item" 
                                ></weed-card>
                                <accessory-card 
                                  v-else
                                  :callback="goToLocationProductDetail" 
                                  :item="item" 
                                ></accessory-card>
                              </template>
                              <template v-else>
                                <weed-card-list 
                                  v-if="item.product_family == 'cannabis'" 
                                  :callback="goToLocationProductDetail" 
                                  :item="item" 
                                ></weed-card-list>
                                <accessory-card-list
                                  v-else
                                  :callback="goToLocationProductDetail" 
                                  :item="item" 
                                ></accessory-card-list>
                              </template>

                            </div>
                            <div class="container mt-15 text-center" v-if="category.from_categories_filtered_products.length < 1">
                              <em class="font-color">No Product Found.</em>
                            </div>
                          </div>
                
                        </template>
                      </div>
                    </div>
                  </div>

                </div>
                <!-- product card display area ends-->

              </div>
            </div>
          </div>

        </section>
      </main>

      <!-- <filter-product-mobile :class="filter_mobile ? 'active' : ''" :categories="categories"></filter-product-mobile> -->
      <new-sm-product-filter :sizes="sizes" :activesubcategory="activeCategorySubcategories" />
      <!-- <add-to-cart-modal :callback="goToLocationProductDetail" /> -->
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
import Env from '@/env';
import { mapGetters, mapActions, mapMutations } from "vuex";
//import Item from "@/Components/Pages/PageComponents/StoreProfile/ItemV2";

import FilterProduct from "@/Components/Pages/PageComponents/StoreProfile/FilterProduct";
import NewSmProductFilter from "@/Components/Pages/PageComponents/StoreProfile/NewSmProductFilter";
import SkeletonMain from "@/Components/Pages/PageComponents/StoreProfile/Skeleton";
import SkeletonFilterWithItem from '@/Components/Pages/PageComponents/StoreProfile/SkeletonFilterWithItem.vue';
import SkeletonItem from "@/Components/Pages/PageComponents/StoreProfile/SkeletonItem";
import SkeletonItemList from "@/Components/Pages/PageComponents/StoreProfile/SkeletonItemList";
import DisplayItemType from "@/Components/Pages/PageComponents/StoreProfile/DisplayItemType";

import AddToCartModal from '@/Components/Pages/PageComponents/StoreLanding/AddToCartModal'; // Sharing from landing page
import Helpers from '@/Components/Helpers/Helpers';
import carousel from "vue-owl-carousel";
import moment from 'moment';

import LoyalityApis from '@/Components/Controllers/LoyalityApis';
import LocationApis from '@/Components/Controllers/LocationApis';
import UserApis from '@/Components/Controllers/UserApis';
import CartApis from '@/Components/Controllers/CartApis';
import BusinerssProfileApis from '@/Components/Controllers/BusinerssProfileApis';
var VueScrollTo = require('vue-scrollto');
import * as _ from 'lodash';
import VueSlickCarousel from 'vue-slick-carousel';
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
SwiperCore.use([Navigation, Pagination])

export default {
  components: {
    SkeletonMain,
    SkeletonFilterWithItem,
    SkeletonItem,
    SkeletonItemList,
    carousel,
    FilterProduct,
    NewSmProductFilter,
    AddToCartModal,
    VueSlickCarousel,
    DisplayItemType,
    Swiper,
    SwiperSlide,
  },
  name: "StoreProfile",
  metaInfo() {
    return { 
      title: `${this.vg_businessProfile && this.vg_businessProfile.name ? this.vg_businessProfile.name : ''} Cannabis Store in ${this.vg_selectedStore.address && this.vg_selectedStore.address.city ? this.vg_selectedStore.address.city : 'Canada'}`,
      meta: [
        { name: 'description', content:  `${this.vg_businessProfile && this.vg_businessProfile.name ? this.vg_businessProfile.name : ''} Cannabis Store in ${this.vg_selectedStore.address && this.vg_selectedStore.address.city ? this.vg_selectedStore.address.city : 'Canada'}`,},
        { property: 'og:title', content: `${this.vg_businessProfile && this.vg_businessProfile.name ? this.vg_businessProfile.name : ''} Cannabis Store in ${this.vg_selectedStore.address && this.vg_selectedStore.address.city ? this.vg_selectedStore.address.city : 'Canada'}`,},
      ]
    }
  },
  data() {
    return {
      breakpoints: { 
        3000: {
          slidesPerView: 9,
        }, 
        1920: {
          slidesPerView: 9,
        }, 
        1400: {
          slidesPerView: 9,
        }, 
        1024: {
          slidesPerView: 5,
        }, 
        991: {
          slidesPerView: 3,
        },
        820: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 2,
        },
        320: {
          slidesPerView: 2,
        }
      },
      nav: {
        nextEl: ".arrow-next",
        prevEl: ".arrow-prev",
      },
      loadMoreCount: 1,
      categoryStripeStickyAt: 99,
      sizes: [],
      initialSlide: 0,
      loadCount: 0,
      sort: 'default',
      filter_mobile: false,
      isSearchActive: false, // We have got situation is search active , display all product on a page and heading caregoy works as scroll event
      locationNotFound: false,
      // show_map: true,
     //  show_banner: true,
      loadedCategories: false,
      loadedDetail: false,
      loadedCategoryProducts: false,
      storeFeaturedImage: '',
      storeReviewCount: 0,
      hideAt: 0,
      hideBanner: false,
      locationDetail: {},
      loadedLocationDetail: false,
      loadedLocationProducts: false,
      searchText: "",
      dayName: {
        0: 'Sunday',
        1: 'Monday',
        2: 'Tuesday',
        3: 'Wednesday',
        4: 'Thursday',
        5: 'Friday',
        6: 'Saturday',
      },
      searchedProducts: [],
      searchbar: false,
      categorybar: true,
      todayOpening: "",
      showStoreHours: false,
      store_slug: "",
      onLoadCategories: [],
      categories: [
      ],
      favLocationList: [],
      favLocationObj: {},
      isFavLocation: false,
      //categoryNextNav: true,
      activeCategorySubcategories: [],
      activecategoryintensity: '',
      isActiveSubCat: false,
      locationAllCategoriesObj : {},
    };
  },
  computed: {
    /**
     * Slider per view
     */
    slidePerView() {
      if(window.innerWidth <= 768) {
        return 2;
      } else if(window.innerWidth <= 820) {
        return 3;
      } else if(window.innerWidth <= 991) {
        return 4;
      } else {
        this.onLoadCategories.length >= 9 ? 9 : this.onLoadCategories.length
      }
    },
    /**
     * If hide header present in query 
     * */
    hideHeader() {
      return (this.$route.query['noh'] && ( (this.$route.query['noh'] == 1) || (this.$route.query['noh'] == 'true') )   ) ? true : false;
      // if(this.$route.query.noh && (this.$route.query.noh == 1) ){
      //   return true;
      // }
      // return false;
    },
    /**
     * Kiosk mode
     */
    kioskMode() {
       return (this.$route.query['kiosk'] && ( (this.$route.query['kiosk'] == 1) || (this.$route.query['kiosk'] == 'true') ) ) ? true : false;
    },

    sortKeyValues() {
      return Env.productSortKeyValues;
    },

    getActiveCategoryProductCount () {
      let item = this.displayCategoryProduct.filter(item => item.active);
      if(item.length > 0){
        if(this.vg_filters.from_categories && (this.vg_filters.from_categories.length == 0) ){
          return item[0].total_items  ;
        } else {
          return item[0].from_categories_filtered_products_count;
        }
      }
      return 0;
    },

    displayCategoryProduct() {
      return this.onLoadCategories;
    },

    /**
     * Gives the count of currently active filters
     */
    activeFilterCount() {
      return Helpers.getActiveFilterCount(this.vg_filters);
    },

    /**
     * Gives active filter tags
     */
    activeFilterTags() {
      return Helpers.getActiveFilterTags(this.vg_filters);
    },

    userLoggedIn() {
      if (this.$store.getters.getLoggedInUserId != '') {
        return true;
      }
      return false;
    },
    
    ...mapGetters({
     // vg_activeFilter: "searchproduct/activeFilter",
      vg_emailVerified: "emailverification/verified",
      vg_selectedStore: "location/selected",
      vg_cartid: "cart/id",
      vg_orderNotification: "orderhistory/orderNotification",
      vg_storeProfileRecord: "storeprofile/storeProfileRecord",
      vg_guestLandedQueries: "location/guestLandedQueries",
      vg_businessProfile: "businessprofile/detail",
      vg_filters: "searchproduct/searchFilter",   
      vg_userId: "getLoggedInUserId",   
      vg_currentActiveCategory: "searchproduct/currentActiveCategory",
      vg_storeItemDisplayType: "storeprofile/itemDisplayType",
    }),
   
  },

  watch: {
    'vg_emailVerified'() {
      // on email verified the height gets changed of header
      this.$nextTick(() => {
        let headerEle = document.getElementById('header');
        if(headerEle){
          this.categoryStripeStickyAt = headerEle.clientHeight;
        }
      });
    },

    'getActiveCategoryProductCount'(val){
      bus.$emit('filter-selected-category-product-count', val)
    },

    'vg_userId'(val){
      if(val){
        Helpers.setPubNubUserLocationSubscribe({ 
          user_id: val, 
          location_id: this.locationDetail.id
        });
      }
    },

    onLoadCategories: {
      deep: true,
      handler: function(val) {
        let activeMasterCat = _.find(val, 'active');
        if( _.isEmpty(activeMasterCat) == false ){
          this.activeCategorySubcategories = activeMasterCat.from_categories;
        } else {
          this.activeCategorySubcategories = [];
        }
      }
    },

    'favLocationList'(favList) {
      let hasIdOnfav = _.find(favList, { id: this.locationDetail.id });
      if (hasIdOnfav == undefined) {
        this.isFavLocation = false;
      } else {
        this.isFavLocation = true;
      }
    },

    'userLoggedIn'(val) {
      if (val) {
        this.fetchLocationFav();
      }
    },
  },

  created() {
    // Set the location to blank so that on header it do not show old location, on mount we are refetching and setting selected location
    // before we clear lets set this location id
    // if(this.vg_selectedStore.id) {
    //   this.va_setPastSelectedLocationId(this.vg_selectedStore.id);
    // }
    // this.va_setSelectedLocation({});
  },

  async mounted() {


    // Reset filter
    // if (this.vg_storeProfileRecord.data.length == 0) {
    //   // at top to revent double api trigger
    //   this.clearAllFilters();
    // }
    // this.va_setEmptySearchFilter();
    const self = this;
    this.loadedDetail = false;
  
    /**
   * Mobile filter on/off
   */
    bus.$on('open-mobile-filter', async (payload) => {
      self.filter_mobile = payload;
    })

    bus.$on('close-filter', (payload) => {
      this.va_setActiveFilter(payload)
    })

    /**
     * Mobile filter show category, handles mobile category click
     */
    bus.$on('show-mobile-category', async (payload) => {
     if(this.isSearchActive){
        this.scrollToDiv('#category_'+ payload.category.id,null, true)
      } else {
        this.changeCategory(payload.index);
        this.scrollToDiv('#section-search-results',null, true)
      }
    })
    
    // let businessRes = await BusinerssProfileApis.fetchBusinessProfile(this.$route.params.business_slug);
    // if(businessRes.status != 200){
    //   // Its invalid business redirect to valid one
    //   this.va_snackbar({
    //     type: "warning",
    //     message: "Cannot find business."
    //   });
    //   return this.$router.push({ 
    //     name: 'HomePage', 
    //     params: {
    //       business_slug: Env.defaultBusinessSlug 
    //     },
    //     query: this.$route.query,
    //   });
    // }

    // Fetch store detail by slug
    // let res = await LocationApis.fetchBySlug(this.$route.params.store_slug);
    let location_id = this.vg_selectedStore.id;
    this.loadedDetail = true;
    
    if (!location_id) {
      this.locationNotFound = true;
      this.va_snackbar({
        type: "warning",
        message: "Cannot find the store."
      });
      return false;
    }

    // Once we get loction fetch all categories of this location
    let locationAllCategories = await LocationApis.fetchAllLocationCategories(location_id);
    if(locationAllCategories.status == 200){
      this.locationAllCategoriesObj = await Helpers.collectAllCategoriesInObj(locationAllCategories.data.payload);
    }

    // Set Location data
    this.locationDetail = this.vg_selectedStore;
    // this.va_setSelectedLocation(res.data.payload);

    //this.va_setBrands(this.locationDetail.id);// fetch all brands for the selected location
    this.loadedLocationDetail = true;
    // if user is guest only 
    if (this.vg_guestLandedQueries['guest-only'] || (this.vg_guestLandedQueries['guest-only'] == 'true') || this.$route.query['guest-only'] || this.$route.query['kiosk'] ) {
      // then check on kiosk_settings
      // this.show_banner = this.locationDetail.settings.kiosk_settings && this.locationDetail.settings.kiosk_settings.is_enabled ? this.locationDetail.settings.kiosk_settings.show_banner : true
      // we dont have mao now
      // this.show_map = this.locationDetail.settings.kiosk_settings  && this.locationDetail.settings.kiosk_settings.is_enabled? this.locationDetail.settings.kiosk_settings.show_map : true;
      // next is note down guest landed time 
      this.va_setGuestLandedTime(moment().format())
    }
    
    // we dont have map now
    // if (this.vg_guestLandedQueries['hide-map']) {
    //   this.show_map = false
    // }

    // Fetch location required data
    self.fetchLocationFav();
    // fav products
     
    //console.log(this.vg_storeProfileRecord)
    // Condition if we are coming back from history check
   
    // if (this.vg_storeProfileRecord.insertHistory && this.vg_storeProfileRecord.data.length > 0) {
    //   // console.log('history back')
    //   // then direct append past record
    //   self.onLoadCategories = this.vg_storeProfileRecord.data;

    //   let current_cat_product_form = await self.currentActiveCategoryProductForm();
    //   if( (current_cat_product_form == 'dried flower') || (current_cat_product_form == 'pre rolled') ){
    //     let params = Helpers.generateSizeUrlParameter(self.vg_filters, self.vg_currentActiveCategory);
    //     self.sizes = await LocationApis.getLocationCategorySizes(self.vg_selectedStore.id, params);
    //   }

    //   this.loadedLocationProducts = true;
    //   this.va_setStoreProfileRecord({
    //     insertHistory: false,
    //     data: [],
    //   });
    //   this.loadedCategories = true;
    //   //this.categoryNextNavMethod();
    //   this.loadedCategoryProducts = true;

    //   // Now need to set the select category at center positions on scrollbar
    //   let activeHistoryCatIndex = _.findIndex(self.onLoadCategories, function(o) { return o.active });
    //   if(activeHistoryCatIndex){
    //     self.initialSlide = activeHistoryCatIndex;
    //   }
    // } else {
      // console.log('no history');
      // this.clearAllFilters();
      // Fetch new records, by default set sort to default
     // this.vg_filters.sort = 'default';

      this.va_setSearchFilterEachHead({ 
        key: 'sort',
        value: 'default'
      });

     
      const catStore =  this.vg_filters.from_categories ;
      
      // this.vg_filters.from_categories = null
      this.isActiveSubCat =  this.vg_filters.from_categories && this.vg_filters.from_categories.length > 0 ? true : false;
      let params = Helpers.generateUrlParameter(this.vg_filters);
     // this.vg_filters.from_categories = [4189];
      // console.log(this.vg_filters)


      let categoryWithProductsPromise = LocationApis.categoryWithProducts(this.locationDetail.id, params, true); // passing true will escape subcat
      let locationCartPromise = true; // being fetch from sidebar cart //CartApis.locationCart(this.locationDetail.id, Helpers.getLocationCartFullUrl(this));
      Promise.all([categoryWithProductsPromise, locationCartPromise]).then(async function (res) {
        
        if(res[0]  && res[0].status && res[0].status == 200){
           let mainResult = res[0].data.payload;
            mainResult = _.orderBy(mainResult, ['sort_order', 'id'], ['asc', 'asc']);
            // child sort
            mainResult.map(item => {
              item.subCategory = _.orderBy(item.subCategory, ['sort_order', 'id'], ['asc', 'asc']);
            })
            
           let formattedCategories = await self.assignProductInCategory(mainResult); // featured is removed now only categories

           self.onLoadCategories = formattedCategories;
            // It will bring the first item selectd by default on load, now lets chat that for initial load only 
            if (self.$route.query['category'] && self.$route.query['category'] != '') {

              // Now match menu with the category 
              // Get the index of category which has name self.$route.query['category']
              let indexOfUrlPassedCategory = _.findIndex(self.onLoadCategories, function(o) { return o.title == self.$route.query['category']; });
              if(indexOfUrlPassedCategory > -1){
                // this will set the active category 
                self.changeCategory(indexOfUrlPassedCategory);
                // console.log('set active acategory for url category')
                self.initialSlide = indexOfUrlPassedCategory;
              } else {
                await self.vm_currentCategory(self.onLoadCategories[0]);
                
                // get sizes only if the first product form is dried flower
                let current_cat_product_form = await self.currentActiveCategoryProductForm();
                if( (current_cat_product_form == 'dried flower') || (current_cat_product_form == 'pre rolled') ){
                  let params = Helpers.generateSizeUrlParameter(self.vg_filters, self.vg_currentActiveCategory);
                  self.sizes = await LocationApis.getLocationCategorySizes(self.vg_selectedStore.id, params);
                }
                
              }
            } else {
              // fall back set first as the selected cat
              await self.vm_currentCategory(self.onLoadCategories[0]);
              // get sizes only if the first product form is dried flower
              let current_cat_product_form = await self.currentActiveCategoryProductForm();
              if( (current_cat_product_form == 'dried flower') || (current_cat_product_form == 'pre rolled') ){
                let params = Helpers.generateSizeUrlParameter(self.vg_filters, self.vg_currentActiveCategory);
                self.sizes = await LocationApis.getLocationCategorySizes(self.vg_selectedStore.id, params);
              }
            }
        }

        if(catStore && catStore.length >  0){
          self.va_setSearchFilterEachHead({ 
            key: 'from_categories',
            value: catStore
          });
          bus.$emit('filter-now', true)
        } else {
          self.loadedCategoryProducts = true;
        }
      })

   // } history remove

    // get featured image of store
    if (this.locationDetail.images && this.locationDetail.images.length > 0) {
      this.storeFeaturedImage = Helpers.getStoreFeaturedImage(this.locationDetail.images);
    }
    
   // if (this.vg_guestLandedQueries['guest-only'] && this.vg_guestLandedQueries['guest-only'] != 'true') {
      // set scrolling events
      // let headerHeight = document.getElementsByClassName('header');
      // let bannerHeight = document.getElementsByClassName('store-profile-banner');
      // if(headerHeight && headerHeight){
     
      //   if ((bannerHeight.length > 0) && (headerHeight.length > 0) ) {
      //     this.hideAt = bannerHeight[0].scrollHeight + headerHeight[0].scrollHeight;
      //   } else {
      //     // try unless you got that id
      //     const interval = setInterval(() => {
      //       if (bannerHeight.length > 0) {
      //         clearInterval(interval);
      //         self.hideAt = bannerHeight[0].scrollHeight + headerHeight[0].scrollHeight;
      //       }
      //     }, 1000)
      //   }
      //   window.addEventListener("scroll", this.handleScroll);
      // }
      
    //}

    

    /**
     * Filter listen and replace the initial loaded data data
     */
    bus.$on('loaded-filtered-product', async (payload) => {
      self.loadedCategoryProducts = payload;
    })

    bus.$on('filtered-store-categories', async (res) => {
      // this gets triggered when we get filtered products
      self.loadMoreCount = 1;
      self.loadedCategories = false;
      // setTimeout(async () => {
        // 0 mean with sub cat, 1 is master cat
        // on change any filter, if sub cat is selected then passvalue to sub cat
        if(res[0].status == 200){

          let mainResult = res[0].data.payload;
          mainResult = _.orderBy(mainResult, ['sort_order', 'id'], ['asc', 'asc']);
          // child sort
          mainResult.map(item => {
            item.subCategory = _.orderBy(item.subCategory, ['sort_order', 'id'], ['asc', 'asc']);
          })

          let formattedCategories = await self.assignProductInCategory(mainResult);// this will modify master cat -> good 
           // Now before pass lets check the stored category is found in result or not if no the push it with blank data
          let letsFind = _.find(formattedCategories, { id: this.vg_currentActiveCategory.id});
          if(letsFind == undefined || letsFind == null){
            // Push the curent selected cat as the first item, to prevent the display
            // when logout its attaching blank data so prevent if its null
            // only add the category if it has cat id mean has data
            if(this.vg_currentActiveCategory.id){
              formattedCategories.map(item => {
                item.active = false;
              })
              formattedCategories = [this.vg_currentActiveCategory].concat(formattedCategories)
            }
          } else  {

          }
           self.onLoadCategories = formattedCategories;
        }
 
          // this will assign product inside sub cat 
          // we can push only if active filter
          if(self.vg_filters.from_categories && (self.vg_filters.from_categories.length > 0) ){
            if(res[1] != null && res[1].status == 200){
              await self.assignProductInSubCategory(res[1].data.payload); // then push product inside that sub cat  
            }
          }

        self.isActiveSubCat = self.vg_filters.from_categories.length > 0 ? true : false;

        let current_cat_product_form = await self.currentActiveCategoryProductForm();
        if( (current_cat_product_form == 'dried flower') || (current_cat_product_form == 'pre rolled') ){
          // when every filter has changed fetch the sizes from vilter var
          let params = Helpers.generateSizeUrlParameter(self.vg_filters, self.vg_currentActiveCategory);
          self.sizes = await LocationApis.getLocationCategorySizes(self.vg_selectedStore.id, params);
        } else {
          self.sizes = [];
        }

        self.loadedCategories = true;
        self.loadedCategoryProducts = true;
        //self.categoryNextNavMethod();

      // }, 500)
    })

    /**
    * Listen if search is active or not 
    * We are going to switch design depending on search active 
    */
    bus.$on('store-profile-active-filter', async (payload) => {
      if (payload) {
        this.isSearchActive = true;
      } else {
        this.isSearchActive = false;
      }
      // scroll to category section

      if (this.vg_guestLandedQueries['guest-only'] && (this.vg_guestLandedQueries['guest-only'] == 'true') || this.$route.query['guest-only']) {
        window.scrollTo(0, 0);
      } else {
        let bannerHeight = document.getElementById('store-profile-banner');
        if(bannerHeight){
          window.scrollTo(0, bannerHeight.offsetHeight);
        }
      }

    })

    // If user is logged in then to set status active
    if(this.userLoggedIn){
      setTimeout(()=> {
        UserApis.addUserLocation(this.$store.getters.getLoggedInUserId, location_id, this.$route.query);
        Helpers.pubnubSubscribeAllChannels({ 
          user_id: this.$store.getters.getLoggedInUserId, 
          location_id: this.locationDetail.id
        });
        Helpers.emitUserActivity();
      }, 1000)
    }

    // Referral link lands on shop page, if it comes with token men its verifying stage dont need to show modal
    if( !this.userLoggedIn && this.$route.query.referral_key && !this.$route.query.token ){
      let loyaltyReferralKeyCheck = await LoyalityApis.validateLoyaltyReferralKey(this.vg_businessProfile.id, this.$route.query.referral_key);
      if(loyaltyReferralKeyCheck.status == 200){
         bus.$emit('show-signup-login-option-modal', {
           modal: true,
           message: loyaltyReferralKeyCheck.data.msg ? loyaltyReferralKeyCheck.data.msg : 'Welcome',
         });
      }
    }


    // Add to scroll also because header height depends on notifications available sometime can have 3 notifications
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("scroll", this.handleResize);
    // lets give time to load and display header content to get exact header height
    this.$nextTick(function () {
      this.handleResize();
    });
    bus.$on('recheck-header-height', async (payload) => {
      this.$nextTick(function () {
        this.handleResize();
      });
    })


    window.addEventListener('scroll', this.trackProductLoad);


  },

  destroyed() {
    window.removeEventListener("scroll", this.handleResize);
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("resize", this.trackProductLoad);
  },

  beforeDestroy() {
    bus.$off('store-profile-active-filter');
    bus.$off('filtered-store-categories');
    bus.$off('loaded-filtered-product');
    bus.$off('close-filter');
    bus.$off('show-mobile-category');
    bus.$off('open-mobile-filter');
    bus.$off('recheck-header-height');
    bus.$off('show-signup-login-option-modal');
    
  },

  methods: {

    /**
     * On scroll track load product
     */

     trackProductLoad() {
      //let productLoadArea = document.getElementById('loadProduct')
      let loadProductEle = this.$refs.loadProduct;
      if(loadProductEle == undefined) return;
      let productBoxHeight = loadProductEle.clientHeight;
      if(productBoxHeight && (window.scrollY > (productBoxHeight - 300) ) ){ //  -330 because load before 1 card
        let activeCatIndex = this.onLoadCategories.findIndex(item => item.active);
        if(activeCatIndex !=  -1) {
          let activeCat = this.onLoadCategories[activeCatIndex];

          if(this.isActiveSubCat) {
            // child cat
            let itemChunksCount = activeCat.from_categories_filtered_products_chunks ? activeCat.from_categories_filtered_products_chunks.length : 0;
            if(itemChunksCount > 1 && itemChunksCount > this.loadMoreCount) {
              this.va_spinner(true);
              this.loadMoreSubCatProduct(activeCatIndex);
            }

          } else {
            // parent cat

            let itemChunksCount = activeCat.items_chunks ? activeCat.items_chunks.length : 0;
            if(itemChunksCount > 1 && itemChunksCount > this.loadMoreCount) {
              this.va_spinner(true);
              this.loadMoreParentCatProduct(activeCatIndex);
            } 
          }


        }
      }
     },

    /**
     * Load more parent products
     */
    loadMoreParentCatProduct: _.debounce(function(activeCatIndex){
      //  find which category is active and how many chunks are loaded
      //let activeCat = this.onLoadCategories[activeCatIndex];
      this.onLoadCategories[activeCatIndex].items_visible = this.onLoadCategories[activeCatIndex].items_visible.concat(this.onLoadCategories[activeCatIndex].items_chunks[this.loadMoreCount])
      this.loadMoreCount++;
      this.va_spinner(false);
     
    }, 1000),


     /**
     * Load more child sub cat products
     */
     loadMoreSubCatProduct: _.debounce(function(activeCatIndex){
      //  find which category is active and how many chunks are loaded
      //let activeCat = this.onLoadCategories[activeCatIndex];
      this.onLoadCategories[activeCatIndex].from_categories_filtered_products_visible = this.onLoadCategories[activeCatIndex].from_categories_filtered_products_visible.concat(this.onLoadCategories[activeCatIndex].from_categories_filtered_products_chunks[this.loadMoreCount])
      this.loadMoreCount++;
      this.va_spinner(false);
     
    }, 1000),
    


    /**
     * 
     * Slice chunk
     */

    sliceIntoChunks(arr, chunkSize) {
      const res = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
          const chunk = arr.slice(i, i + chunkSize);
          res.push(chunk);
      }
      return res;
    },

    prev() {
      if(this.$refs.swiper.$swiper){
        this.$refs.swiper.$swiper.slidePrev()
      }
    },

    next() {
      if(this.$refs.swiper.$swiper){
        this.$refs.swiper.$swiper.slideNext()
      }
    },

    /**
     * Handle resize 
     */
    handleResize(e) {
      if(document.getElementById('header')){
        this.categoryStripeStickyAt = document.getElementById('header').clientHeight;
      } else {
        this.categoryStripeStickyAt = 0;
      }
    },
    /**
     * Scroll to div event
     */
    scrollToDiv: _.debounce( function(divId, index, offsetValue = false) {
      let offset;
      if (offsetValue) {
        offset = -250;
      } else {
        offset = 0;
      }
      var options = {
        easing: 'ease-in',
        offset: offset,
      }
      VueScrollTo.scrollTo(divId, 500, options)
      if(index != null){
         this.categories.map(item => {
          item.active = false;
        });
        this.categories[index].active = true;
      }
      // make that cat active
    }, 500),

    async assignProductInSubCategory(payload) {
      const self = this;
      let sub_cat_products = [];
      let totalProducts = 0;
      payload.forEach(mainitem => {
       
        if (mainitem.products.length > 0) {
          mainitem.products.map(item => {
            // remove discontinued , 0 varaints or all varinats not available
            // if (item.discontinued == false && item.variants && item.variants.length > 0 && Helpers.isAllVariantOutOfStock(item.variants) == false) {
            //   totalProducts++;
            //   sub_cat_products.push(item);
            // }
            // we are going to show out of stock
            if (item.discontinued == false && item.variants && item.variants.length > 0 && Helpers.isAllVariantOutOfStock(item.variants) == false) {
              totalProducts++;
              // here need to add category
              if( self.locationAllCategoriesObj.hasOwnProperty(item.category_id) ){
                item.category = self.locationAllCategoriesObj[item.category_id];
              } else {
                // Just to prevent crash in case no cat found
                item.category = {
                  thc_cbd_value_type: 'range'
                };
              }
              sub_cat_products.push(item);
            }
          })
        }
      })

      // lets show total product on each active category

      bus.$emit('filtered-product-count', totalProducts);
      this.onLoadCategories.map(item => {
         if(item.active){
            let subCatProductsChunks = self.sliceIntoChunks(sub_cat_products, 50);
            item.from_categories_filtered_products = sub_cat_products;
            item.from_categories_filtered_products_chunks = subCatProductsChunks;
            item.from_categories_filtered_products_visible = subCatProductsChunks[0];
            item.from_categories_filtered_products_count = sub_cat_products.length
         } else {
            item.from_categories_filtered_products = [];
            item.from_categories_filtered_products_count = 0;
            item.from_categories_filtered_products_chunks = [];
            item.from_categories_filtered_products_visible = [];
         }
      });

    },

    /**
     * Diffrenciate feature/ category and append
     * We need to verify data before passing , few validation like discontinued , no of variants and its availability
     */
    async assignProductInCategory(payload) {
      const self = this;
      let categories = [];
      self.loadedLocationProducts = false;
      self.loadedCategories = false;
      let totalProducts = 0;
      /**
      * Second value is category list and its products
      */
      // let hasActive = false;
      payload.forEach(item => {
        if(item.parent_category == null){
          // now if we have params to active a certain category
          let active = false;
          // Now before adding product on category validate product
          // only push if validation success , 1 must be discontinued  = false, varaints > 0 and at least 1 variant must be available
          let data = [];
          if (item.products && (item.products.length > 0) ) {   
            data = item.products.filter(innerItem => {
              // remove discontinued , 0 varaints 
              if (innerItem.discontinued == false && innerItem.variants && innerItem.variants.length > 0 && Helpers.isAllVariantOutOfStock(innerItem.variants) == false) {
                totalProducts++;
                if( self.locationAllCategoriesObj.hasOwnProperty(innerItem.category_id) ){
                  innerItem.category = self.locationAllCategoriesObj[innerItem.category_id];
                } else {
                  // Just to prevent crash in case no cat found
                  innerItem.category = {
                    thc_cbd_value_type: 'range'
                  };
                }
                return innerItem;
              }
            })
          }
          if (data.length > 0) {
            // pass if no product as well -remove again
            let itemChunks = self.sliceIntoChunks(data, 50);
            categories.push({
              title: item.name,
              id: item.id,
              location_id: item.location_id,
              active: active,
              image: item.image,
              from_categories: item.subCategory,
              from_categories_filtered_products: [],
              from_categories_filtered_products_count: 0,
              from_categories_filtered_products_chunks: [],
              from_categories_filtered_products_visible: [],
             // items: data,
              items_chunks: itemChunks,
              items_visible: (itemChunks && itemChunks.length) ? itemChunks[0] : [], //  show first item as default
              total_items: data.length,
              product_form: item.product_form,
            })
          }
        }
      })
      if(categories.length > 0){
        // before doing this check if any category is already active in 
        let oldActiveCategory =  _.find(self.onLoadCategories, function(o) { return o.active });
        // index gets chaging lets take id to make active because filters return in different index 
        if(!_.isEmpty(oldActiveCategory)){
          let findNewCategoryIndex = _.findIndex(categories, function(o) { return o.id == oldActiveCategory.id });
          if(findNewCategoryIndex > -1){
            categories[findNewCategoryIndex].active = true;
            self.initialSlide = findNewCategoryIndex;
           // self.assignActiveCatProductIntensity(categories[findNewCategoryIndex]);
          } else {
            categories[0].active = true;
            //self.assignActiveCatProductIntensity(categories[0]);
          }
        } else {
          // if not old then select first as default active
          categories[0].active = true;
          //self.assignActiveCatProductIntensity(categories[0]);
        }
      }
   
      
      if(this.vg_filters.from_categories && (this.vg_filters.from_categories.length == 0)){
        bus.$emit('filtered-product-count', totalProducts);
      }
      // loded all 
      self.loadedLocationProducts = true;
      self.loadedCategories = true;
      //self.categoryNextNavMethod();
      // Now we have 2 state of data from same api, if we have data on 
      // if(this.vg_filters.from_categories.length == 0){ // can be work with loadCount
      // then only assign parent category because if its not 0 its sub cat activated
      // }
      self.va_spinner(false);
      return categories;
    },

    // async categoryNextNavMethod() {
    //   //this.categoryNextNav = this.showNav();
    // },

    // showNav() {
    //   if(window.innerWidth > 1600){
    //     if(this.onLoadCategories.length <= 10){
    //       return false;
    //     }
    //     return true;
    //   } else if(window.innerWidth > 1368){
    //     if(this.onLoadCategories.length <= 10){
    //       return false;
    //     }
    //     return true;
    //   } else if(window.innerWidth > 1024){
    //      if(this.onLoadCategories.length <= 5){
    //       return false;
    //     }
    //     return true;
    //   } else if(window.innerWidth > 991){
    //     if(this.onLoadCategories.length <= 4){
    //       return false;
    //     }
    //     return true;
    //   } else {
    //     if(this.onLoadCategories.length <= 2){
    //       return false;
    //     }
    //     return true;
    //   }
    // },


    /**
     * Fetch fav location 
     */
    async fetchLocationFav() {
      // its pending for now  

      if (this.$store.getters.getLoggedInUserId) {
        // fetch products with location it will store on vuex auto
        UserApis.fetchFavProducts(); 

        
        this.favLocationList = await UserApis.fetchFavLocations();
        let hasIdOnfav = _.find(this.favLocationList, { id: this.locationDetail.id });
        if (hasIdOnfav == undefined) {
          this.isFavLocation = false;
        } else {
          this.isFavLocation = true;
        }
      } else {
        this.favLocationList = [];
      }
    },

    /**
     * Fav location
     */
    async favouriteLocation() {
      if (!this.$store.getters.getLoggedInUserId) {
        this.va_snackbar({
          message: "Please login to proceed.",
          type: "warning",
        })
        return;
      }
      this.va_spinner(true);
      let res = await UserApis.addUserFavLocation(this.locationDetail.id);
      if (res.status == 201) {
        // success
        let reFetchIds = await UserApis.fetchFavLocations();
        this.favLocationList = reFetchIds;
      }
      this.va_spinner(false);
      this.va_snackbar({
        message: res.status == 201 ? res.data.msg : res.response.data ? res.response.data.msg : "Location favourite failed.",
        type: res.status == 201 ? "success" : "warning",
      })
    },

    /**
     * Unfav location
     */
    async unFavouriteLocation() {

      if (!this.$store.getters.getLoggedInUserId) {
        this.va_snackbar({
          message: "Please login to proceed.",
          type: "warning",
        })
        return;
      }
      this.va_spinner(true);
      let res = await UserApis.userUnFavLocation(this.locationDetail.id);
      if (res.status == 200) {
        // success
        let reFetchIds = await UserApis.fetchFavLocations();
        this.favLocationList = reFetchIds;
      }
      this.va_spinner(false);
      this.va_snackbar({
        message: res.status == 200 ? res.data.msg : res.response.data ? res.response.data.msg : "Location favourite failed.",
        type: res.status == 200 ? "success" : "warning",
      })
    },

    switchToSearchbar() {
      this.searchbar = true;
      this.categorybar = false;
      // Now add cursor on this item
      document.getElementById('search_text_bottom').focus();
    },

    switchToCategorybar() {
      this.searchText = "";
      this.searchbar = false;
      this.categorybar = true;
    },

    handleScroll() {
      let w = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;
        
      // hide only if product is more than 6
      if (window.scrollY > this.hideAt) {
        this.hideBanner = true;
        // if(w > 991){
        if (this.searchbar) {
          document.getElementById("search_text_top").focus();
        }
      } else if (window.scrollY < this.hideAt) {
        this.hideBanner = false;
        if (this.searchbar) {
          document.getElementById("search_text_bottom").focus();
        }
      }
    },
    /**
     * Get contact value from object
     */
    getContactValue(arr, type, field) {
      let obj = _.find(arr, { 'type': type });
      if (obj != undefined) {
        return obj[field];
      }
      return '';
    },

    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push({ name: 'HomePage', query: this.$route.query, });
    },

    /**
     * Search product
     */
    searchProduct() {
      let queryToremove =  ['verify_email', 'category', 'token', 'signup', 'source', 'signup_token'];
      if(this.vg_userId){
        queryToremove.push('referral_key')
      }
      this.$router.push({ 
        name: 'SearchProductResult',
        params:{
          store_slug: this.vg_selectedStore.slug,
        },
        query: { ...Helpers.refineQuery(queryToremove,this.$route.query), ...{ product_name: this.searchText } }
      })
    },

    /**
     * Change category Tab
     */
    async changeCategory(index) {
      this.va_spinner(true);
      window.scrollTo(0, 0);
      // this will create search, need to stop this
      this.loadMoreCount = 1;
      this.vg_filters.from_categories = [];
      this.onLoadCategories.map(item => {
        item.active = false;
        item.from_categories_filtered_products = [];
        item.from_categories_filtered_products_count = 0;
        item.from_categories_filtered_products_chunks = [],
        item.from_categories_filtered_products_visible = [],
        item.items_visible = (item.items_chunks && item.items_chunks.length) ? item.items_chunks[0] : []; // reset chunk
      });
      this.onLoadCategories[index].active = true;
      // set active one
      this.vm_currentCategory(this.onLoadCategories[index]);
      //
      let query = {...this.$route.query, ...{category: this.onLoadCategories[index].title}}
      if(this.$route.query &&  this.$route.query.category && this.$route.query.category != this.onLoadCategories[index].title){
        
          this.$router.replace({ name: "StoreProfile", params: this.$route.params, query: query })
        
      }

      // Reset cbd thc filter because it can be passed on other search
      // this.vg_filters.thc = [];
      // this.vg_filters.cbd = [];
      // Get category instnsity
      // if(this.onLoadCategories[index].items.length > 0){
      //   let targetProduct = this.onLoadCategories[index].items[0]; // first item
      //   if(targetProduct.cannabis_attributes && targetProduct.cannabis_attributes.product_form){
      //     this.activecategoryintensity = targetProduct.cannabis_attributes.product_form;
      //   } else {
      //     this.activecategoryintensity = '';
      //   }
      //  } else {
      //   this.activecategoryintensity = '';
      //  }

      // Get sizes only if first product is dried flower
      let current_cat_product_form = await this.currentActiveCategoryProductForm();
      if( (current_cat_product_form == 'dried flower') || (current_cat_product_form == 'pre rolled') ){
        let params = Helpers.generateSizeUrlParameter(this.vg_filters, this.onLoadCategories[index]);
        this.sizes = await LocationApis.getLocationCategorySizes(this.vg_selectedStore.id, params);
      } else {
        // Reset sizes because we have sizes filter only on dried flower
        // this.vg_filters.size = []; let not remove active filter unless user manually remove
        this.sizes = [];
      }
     
      this.isActiveSubCat = false; // once change tab disable sub cat filter
      // lets give some time DOM to balance data
      this.$nextTick(function () {
        this.va_spinner(false);
      });

     


      // Now pass the user selected category
        // If user is logged in pass his search params
      if(this.vg_userId){
        // Pass parent category
        this.vg_filters.parent_category = this.vg_currentActiveCategory.id;
        UserApis.pushUserFilters({
          location_id: this.vg_selectedStore.id,
          filters: this.vg_filters
        });
      }
    },

    // Get opening and closing time for all the days of week
    getOpenCloseTime(item) {
      return `${moment(item.open_time, "HH:mm:ss").format("hh:mm a")} - ${moment(item.close_time, "HH:mm:ss").format("hh:mm a")}`;
    },

    todayDayNumber() {
      return new Date().getDay();
    },

    getTodaysOpenCloseSchedule() {
      let todaysSchedule = _.find(this.locationDetail.hours_of_operation, function (o) { return o.day == new Date().getDay(); });
      if (todaysSchedule != undefined) {
        return this.getOpenCloseTime(todaysSchedule);
      }
      return '';
    },

    /**
     * Move to locaiton product detail page
     */
    goToLocationProductDetail(item) {
      // Before push lets store the location details
      // this.va_setStoreProfileRecord({
      //   insertHistory: false,
      //   data: this.onLoadCategories,
      // });
      let queryToremove = ['verify_email', 'category', 'token', 'signup', 'source', 'signup_token'];
      if(this.vg_userId){
        queryToremove.push('referral_key')
      }
      let activeHistoryCatIndex = _.findIndex(this.onLoadCategories, function(o) { return o.active });
      let query = Helpers.refineQuery(queryToremove, this.$route.query);
      if(activeHistoryCatIndex !=  -1)  {
        query.category =  this.onLoadCategories[activeHistoryCatIndex]['title'];
      }
      this.$router.push({ 
        name: 'LocationProductDetail', 
        params: { store_slug: this.$route.params.store_slug, product_id: item.id },
        query,
      })
    },

    assignActiveCatProductIntensity(categoryData) {
      // Always set fall back to remove old value
      if(categoryData.items.length > 0){
        let targetProduct = categoryData.items[0]; // first item
        if(targetProduct.cannabis_attributes && targetProduct.cannabis_attributes.product_form){
          this.activecategoryintensity = targetProduct.cannabis_attributes.product_form;
        } else {
          this.activecategoryintensity = '';
        }
      } else {
        this.activecategoryintensity = '';
      }
    },

    ...mapMutations({
      vm_currentCategory: "searchproduct/currentActiveCategoryMutate",
    }),

    openFlyOutFilterDisplay() {
      bus.$emit('change-flyout-screen', 3)
    },
    openFlyOutSortDisplay() {
      bus.$emit('change-flyout-screen', 4)
    },
    clearAllFilters() {
      bus.$emit('clear-filter', true);
    },

    /**
     * Remove filter from mobile
     */
    removeThisFilter(key, val){
      // first remove key value from filter then do search 
      for(let filterKey in this.vg_filters){
        if(filterKey == key){    
          // If this key is array      
          if ( (Array.isArray(this.vg_filters[filterKey])) && (this.vg_filters[filterKey].length > 0)) {
            this.vg_filters[key] = this.vg_filters[filterKey].filter(e => e !== val)
          } else {
            // It must be string set val to blank
            this.vg_filters[key] = '';
          }
        }
      }
      bus.$emit('filter-now', true);
    },

    /**
     * Active category first product
     */
    currentActiveCategoryProductForm() {
      let categoryObj = this.displayCategoryProduct.filter(item => item.active);
      if(categoryObj.length > 0){
        return categoryObj[0].product_form ? categoryObj[0].product_form : '';
        //return Helpers.getCategoryFirstProductProductForm(categoryObj[0].items);
      }
      return '';
    },

    // /**
    //  * refine unnecessary query
    //  */
    // refineQuery(query) {
    //   let removeObj = ['category', 'verify_email', 'token', 'signup'];
    //   removeObj.forEach( (item) => {
    //     if(query.hasOwnProperty(item)){
    //       delete query[item];
    //     } 
    //   })
    //   return query;
    // },
    /**
     * Collect All categories
     */
    collectAllcategories(bulkCategoryData) {
      if(bulkCategoryData.length > 0){
        let keyval = {};
        bulkCategoryData.forEach(item => {
          // this is for main
          keyval[item.id] = {
            name: item.name,
            id: item.id,
            thc_cbd_value_type: item.thc_cbd_value_type,
          }
          //this is for subcat
          if(item.subCategory && (item.subCategory.length > 0)){
            item.subCategory.forEach(subItem => {
              keyval[subItem.id] = {
                name: subItem.name,
                id: subItem.id,
                thc_cbd_value_type: subItem.thc_cbd_value_type,
              }
            })
          }
        })
        return keyval;
      } 
      return {};
    },

    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      // va_setBrands: "brand/setList",
      va_setActiveFilter: "searchproduct/setActiveFilter",
      va_setSearchFilterEachHead:  "searchproduct/setSearchFilterEachHead",
      va_setEmptySearchFilter: "searchproduct/setEmptySearchFilter",
      va_setSelectedLocation: "location/setSelected",
      va_setPastSelectedLocationId: "location/setPastSelectedLocationId",
      va_setGuestLandedTime: "location/setGuestLandedTime",
      va_setStoreProfileRecord: "storeprofile/setStoreProfileRecord",
    })
  }
};
</script>
<style scoped>
.banner-bg{
   background: #ededed;
}
.storeprofile-category-band{
  position: sticky;
  /* top: 99px; */
  z-index: 4;
}
.storeprofile-category-band
.main.site-wrapper.no-header .storeprofile-category-band{
  top: 0px;
}
.has-order-notification .storeprofile-category-band{
  top: 150px;
}
.category-list {
  width: 94%;
  white-space: nowrap;
  position: relative;
}
/* header.header.fixed {
  position: fixed;
  width: 100%;
  background: #fff;
  z-index: 99;
} */
.menu-fixed {
  position: fixed;
  top: 60px;
  z-index: 9;
  left: 0;
  background: #fff;
  width: 100%;
}
.store-profile.banner,
.selected-store-info {
  height: inherit;
  transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
}
.store-profile.banner.hide,
.selected-store-info.hide {
  height: 0;
  overflow: hidden;
}
.profile-tab-at-head {
  position: relative;
}
header.header .profile-tab-hide {
  height: 0px;
  transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
  overflow: hidden;
}
header.header .profile-tab-show {
  height: 55px;
  transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
}
.hide-body-tabs .search-bar {
  /* height: 0px; */
  transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  visibility: hidden;
}
.header-search-overlay.hide {
  height: 0;
  transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
}
.header-search-overlay.show {
  height: auto;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  position: absolute;
  width: 100%;
  bottom: 0px;
  background: white;
}
section.header-search-overlay.hide .search-bar {
  visibility: hidden;
  height: 0;
  overflow: hidden;
}
.relative {
  position: relative;
}
section.body-searchbar .search-bar {
  /* position: absolute; */
  top: 0;
  width: 100%;
  background: #fff;
}
section.body-searchbar.hide .search-bar {
  height: 0px;
  overflow: hidden;
}
section.body-searchbar.show .search-bar {
  height: auto;
  overflow: hidden;
}
.category-list {
  width: 90%;
  white-space: nowrap;
}

button.button.is-filter-toggle {
  margin-top: 15px;
}
.header-search-overlay button.button.is-filter-toggle {
  margin-top: 0px;
}
.dropdown-menu.is-active {
  display: block;
  width: auto;
}
a.dropdown-item .timing {
  width: 150px;
}
a.dropdown-item .day {
  width: 148px;
}
.banner.store-profile {
  background-size: cover !important;
  background-position: center center !important;
}

a.category-scroll-prev img,
a.category-scroll-next img {
  height: 20px;
}
.body-cat-search-stripe.fixed {
  position: sticky;
  top: 99px; 
  z-index: 9;
  width: 100%;
}
.has-notification .body-cat-search-stripe.fixed {
  top: 150px;
}
.header-top {
  position: relative;
  z-index: 10;
}
.vspacer-55px {
  height: 55px;
}
.vspacer-0px {
  height: 0px;
}
header.header .profile-tab-show {
  visibility: hidden;
  opacity: 0px;
}
.search-bar {
  border-top: none !important;
  border-bottom: none !important;
  box-shadow: 0 0px 11px #ccc;
}

.search-bar .category-list {
  width: 100%;
  white-space: nowrap;
}
.min-80vh{
  min-height: 80VH;
}
@media screen and (max-width: 768px) {
  /* .store-profile main.content-wrapper{
    margin-top: 60px;
  } */
  .storeprofile-category-band{
    top: 59px;
  }
  /* .has-order-notification .storeprofile-category-band {
    top: 110px;
  } */
}

@media screen and (min-width: 1024px) {
  .search-bar .lg-hide-owl-arrow {
    display: none;
  }
}

</style>

